export default "__VITE_ASSET__Daia9YPJ__"